const map = {
	"./about.html": "./src/about.html",
	"./admin.html": "./src/admin.html",
	"./articles.html": "./src/articles.html",
	"./common.blocks/admin-login/admin-login.html": "./src/common.blocks/admin-login/admin-login.html",
	"./common.blocks/advantage-section/advantage-section.html": "./src/common.blocks/advantage-section/advantage-section.html",
	"./common.blocks/articles-section/articles-section.html": "./src/common.blocks/articles-section/articles-section.html",
	"./common.blocks/big-slider/big-slider.html": "./src/common.blocks/big-slider/big-slider.html",
	"./common.blocks/burger-menu/burger-menu.html": "./src/common.blocks/burger-menu/burger-menu.html",
	"./common.blocks/clients-section/clients-section.html": "./src/common.blocks/clients-section/clients-section.html",
	"./common.blocks/contacts-section/contacts-section.html": "./src/common.blocks/contacts-section/contacts-section.html",
	"./common.blocks/employee-preview/employee-preview.html": "./src/common.blocks/employee-preview/employee-preview.html",
	"./common.blocks/example-preview/example-preview.html": "./src/common.blocks/example-preview/example-preview.html",
	"./common.blocks/example-section/example-section.html": "./src/common.blocks/example-section/example-section.html",
	"./common.blocks/faq-section/faq-section.html": "./src/common.blocks/faq-section/faq-section.html",
	"./common.blocks/feedback-section/feedback-section.html": "./src/common.blocks/feedback-section/feedback-section.html",
	"./common.blocks/footer/footer.html": "./src/common.blocks/footer/footer.html",
	"./common.blocks/header/header.html": "./src/common.blocks/header/header.html",
	"./common.blocks/hero-section/hero-section.html": "./src/common.blocks/hero-section/hero-section.html",
	"./common.blocks/history-block/history-block.html": "./src/common.blocks/history-block/history-block.html",
	"./common.blocks/history-section/history-section.html": "./src/common.blocks/history-section/history-section.html",
	"./common.blocks/info-preview/info-preview.html": "./src/common.blocks/info-preview/info-preview.html",
	"./common.blocks/location-section/location-map.html": "./src/common.blocks/location-section/location-map.html",
	"./common.blocks/location-section/location-section.html": "./src/common.blocks/location-section/location-section.html",
	"./common.blocks/map/map.html": "./src/common.blocks/map/map.html",
	"./common.blocks/nav/nav.html": "./src/common.blocks/nav/nav.html",
	"./common.blocks/portfolio-section/portfolio-section.html": "./src/common.blocks/portfolio-section/portfolio-section.html",
	"./common.blocks/reviews-section/reviews-section.html": "./src/common.blocks/reviews-section/reviews-section.html",
	"./common.blocks/search-block/search-block.html": "./src/common.blocks/search-block/search-block.html",
	"./common.blocks/service-overview/service-overview.html": "./src/common.blocks/service-overview/service-overview.html",
	"./common.blocks/service-preview/service-preview.html": "./src/common.blocks/service-preview/service-preview.html",
	"./common.blocks/services-section/services-section.html": "./src/common.blocks/services-section/services-section.html",
	"./common.blocks/social/social.html": "./src/common.blocks/social/social.html",
	"./common.blocks/stages-section/stages-section.html": "./src/common.blocks/stages-section/stages-section.html",
	"./common.blocks/tags/tags.html": "./src/common.blocks/tags/tags.html",
	"./common.blocks/ui/favicon/favicon.html": "./src/common.blocks/ui/favicon/favicon.html",
	"./common.blocks/ui/gtm/gtm-body.html": "./src/common.blocks/ui/gtm/gtm-body.html",
	"./common.blocks/ui/gtm/gtm-head.html": "./src/common.blocks/ui/gtm/gtm-head.html",
	"./common.blocks/ui/pagination/pagination.html": "./src/common.blocks/ui/pagination/pagination.html",
	"./common.blocks/ui/popup/popup-employee.html": "./src/common.blocks/ui/popup/popup-employee.html",
	"./common.blocks/ui/popup/popup-feedback.html": "./src/common.blocks/ui/popup/popup-feedback.html",
	"./common.blocks/ui/popup/popup-location.html": "./src/common.blocks/ui/popup/popup-location.html",
	"./common.blocks/ui/popup/popup-portfolio.html": "./src/common.blocks/ui/popup/popup-portfolio.html",
	"./common.blocks/ui/popup/popup-review.html": "./src/common.blocks/ui/popup/popup-review.html",
	"./common.blocks/ui/popup/popup-success.html": "./src/common.blocks/ui/popup/popup-success.html",
	"./common.blocks/ui/popup/popup.html": "./src/common.blocks/ui/popup/popup.html",
	"./common.blocks/ui/scroll-up/scroll-up.html": "./src/common.blocks/ui/scroll-up/scroll-up.html",
	"./contacts.html": "./src/contacts.html",
	"./error-page.html": "./src/error-page.html",
	"./faq.html": "./src/faq.html",
	"./index.html": "./src/index.html",
	"./news-details.html": "./src/news-details.html",
	"./policy-page.html": "./src/policy-page.html",
	"./portfolio.html": "./src/portfolio.html",
	"./search-page.html": "./src/search-page.html",
	"./service-details.html": "./src/service-details.html",
	"./services.html": "./src/services.html"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive \\.(html)$";